import {cDisplay} from '../creator/cDisplay'
import { infoBubble } from '../creator/cDisplayObjects/infoBubble';
import { cGame } from '../creator/cGame';
import { cContainer } from '../creator/cGameObjects/cContainer';
import {cScene} from '../creator/cScene'


// const mapData = {
//   'step_0': { 
//     enable:['step_1'],
//     popup_ref: 'step_1',
//     popup_txt: 'hier geht es los' 
//   },
//   'step_1': { 
//     enable:['step_2'],
//     popup_ref: 'step_2',
//     popup_txt: 'Am Bahnhof aussteigen und Die Stadt kennennlernen' 
//   },
//   'step_2': { 
//     enable:['step_3'],
//     popup_ref: 'step_3',
//     popup_txt: 'Los, in den bus mitfahren' 
//   },
//   'step_3': { 
//     enable: ['step_4_1','step_4_2','step_4_3'],
//     popup_ref: 'step_4_1',
//     popup_txt: 'Los, in den bus mitfahren' 
//   },
//   'step_4_1': { 
//     enable: ['step_5'],
//     completed:['step_4_1','step_4_2','step_4_3'],
//     popup_ref: 'step_4_1',
//     popup_txt: 'Los, in den bus mitfahren' 
//   },
//   'step_4_2': { 
//     enable: ['step_5'],
//     completed:['step_4_1','step_4_2','step_4_3'],
//     popup_ref: 'step_4_2',
//     popup_txt: 'Los, in den bus mitfahren' 
//   },
//   'step_4_3': { 
//     enable: ['step_5'],
//     completed:['step_4_1','step_4_2','step_4_3'],
//     popup_ref: 'step_4_3',
//     popup_txt: 'Los, in den bus mitfahren' 
//   },
//   'step_5': { 
//     enable: ['step_7'],
//     popup_ref: 'step_7',
//     popup_txt: 'Erfahre was die kinder in der Schule machen wollen' 
//   },
//   'step_7': { 
//     enable: ['step_8'],
//     popup_ref: 'step_8',
//     popup_txt: 'Erfahre was die kinder in der Schule machen wollen' 
//   },
//   'step_8': { 
//     enable: ['step_9'],
//     popup_ref: 'step_9',
//     popup_txt: 'Ein foto für das klassenbuch' 
//   },
//   'step_9': { 
//     enable: ['step_10'],
//     popup_ref: 'step_10',
//     popup_txt: 'Grundrechte sind mehr als hokus-pokus' 
//   },
//   'step_10': { 
//     enable: ['step_11'],
//     popup_ref: 'step_11',
//     popup_txt: 'Grundrechte sind mehr als hokus-pokus' ,
//     popup_dir: 'up',
//     shiftY:400
//   },
//   'step_11': { 
//     enable: [],
//     popup_ref: 'step_11',
//     popup_txt: 'Grundrechte sind mehr als hokus-pokus',
//   }

// }

export class mapDisplay extends cDisplay {

  private mapData: any;


  init(){
    super.init();


    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){

        case 'show_info':
          let st = cGame.current.state.get('scene_last_completed' ,-1);
          if (st != -1){     
           let f = this.mapData['step_'+st];
            let pos;
            let popupText 

            if (!this.areStepsCompleted( f )){
              st = this.getNotFinishedStep(f)
              f = this.mapData[st];
              pos = this.getByName(st);
              popupText = f.popup_txt
            }else{
              pos = this.getByName(f.popup_ref);
              popupText = this.getPopuptext(f.popup_ref)
            }

            let yy = (pos.y - 150 + (f.shiftY ? f.shiftY : 0 ) );            
            let b = new infoBubble(this.scene as cScene,{
              value: popupText,
              ofs: pos.x+'x'+yy, 
              dir: f.popup_dir ? f.popup_dir : 'down',
              stalk:'50'
            },(e)=>{
              console.log('CXLOSED');
            });
      
            this.scene.add.existing(b);
            this.add(b);
          }
      
          break;
      }
    })

  }

  getPopuptext(data){
    return this.mapData[data].popup_txt
  }

  getStateByName(nm){
    let s_name:string =  'scene_completed_' +String(nm).replace('step_','');
    return cGame.current.state.get( s_name ,0);
  }

  getNotFinishedStep(data){
    var a=0;
    for (a=0; a < data.completed.length; a++){
      let nm:string = data.completed[a];
      if ( this.getStateByName(nm) !== 1) return data.completed[a]
    }
    return ''
  }

  areStepsCompleted(data){
    var cc = 0;
    if (data.completed){
      data.completed.forEach((c_nm)=>{
        if ( this.getStateByName(c_nm) === 1) cc++        
      });
      return cc == data.completed.length
    }else{
      return true
    }
  }

  buildScene(){    
    super.buildScene();     

    this.mapData = this.getByName('DATA').modules.data._extraData;

    let holder:cContainer = this.getByName('holder') as cContainer
    let stepsItems = holder.getAll();
    var $this = this;

    stepsItems.forEach( (el:any)=>{
      if (el.name.indexOf('step_') === 0){
        el.visible = false
      }
    });  

    let checkHolder:cContainer = $this.getByName('check_holder');
    checkHolder.removeAll(true);

    Object.keys( this.mapData ).forEach( (k)=>{

      let dotData = this.mapData[k]
      let nm:string = 'scene_completed_' + String(k).replace('step_','');
      let dotState =  Number(this.getStateByName(k));
      let dotRef = this.getByName(k);

      if (dotState === 1 && dotRef){
        dotRef.visible = 1;
        if (this.areStepsCompleted(dotData)){
          dotData.enable.forEach( (nm)=>{
            let toEnable = $this.getByName(nm);
            toEnable.visible = true
          });  
        }
        checkHolder.add(  this.scene.add.sprite( dotRef.x+40, dotRef.y-40, 'map_checkmark' ) )
      }


      // console.log(nm,st,k)

      // if (Number(st) === 1){

      //   let ref = $this.getByName(k);
        
      //   if (ref) {
      //     ref.visible = 1;
        
      //     // check if 
      //     if (ref.completed){
      //       var res = true;
      //       ref.completed.forEach((c_nm)=>{
      //         if (this.getStateByName(c_nm) !== 1){
      //           res = false
      //         }
      //       });
      //       if (!res) {
      //         console.log('NOT COMPLETED')
      //         return
      //       }
      //     }
      //   }

      //   this.mapData[k].enable.forEach((nm)=>{          
      //     let ref = $this.getByName(nm);
      //     var refst = this.getStateByName(nm);
      //     console.log(nm)
      //     ref.visible = 1;
      //     if (refst > 0){
      //       checkHolder.add(  this.scene.add.sprite( ref.x+40, ref.y-40, 'map_checkmark' ) )
      //     }
      //   });

      //}
    });

  }

  public show(opt:boolean){
    this.visible = opt
  }


  public static setCompleted(opt){

  }
}
